
let firebaseConfig
if (FIREBASE_ENVIRONMENT === 'development') {
  firebaseConfig = {
    apiKey: "AIzaSyCYQjdM0xJv9gdwwCtmUg8zDh_TB-mlcjQ",
    authDomain: "playmaker-capture-proto.firebaseapp.com",
    databaseURL: "https://playmaker-capture-proto.firebaseio.com",
    projectId: "playmaker-capture-proto",
    storageBucket: "playmaker-capture-proto.appspot.com",
    messagingSenderId: "720906539275",
    appId: "1:720906539275:web:2ef3a34b2ee87cac2b920e"
  }
} else if (FIREBASE_ENVIRONMENT === 'production') {
  firebaseConfig = {
    apiKey: "AIzaSyA9oMLQ95Fz6p_cJJA8c1EbABb1nGsCUuk",
    authDomain: "tasq-prod.firebaseapp.com",
    databaseURL: "https://tasq-prod.firebaseio.com",
    projectId: "tasq-prod",
    storageBucket: "tasq-prod.appspot.com",
    messagingSenderId: "629784617776",
    appId: "1:629784617776:web:667560089bd47fadbadef5",
    measurementId: "G-HYWTN866MG"
  }
}

export default firebaseConfig